import { MdRefresh, MdSearch } from "react-icons/md";

const DashboardPropertyFilter = ({
  search,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  approvalStatusFilter = "all",
  onApprovalStatusChange,
  onRefresh,
  refreshing = false,
  searchPlaceholder = "Cari judul, lokasi, pemilik, tipe, atau kota...",
}) => {
  return (
    <div className="dashboard-toolbar">
      <div className="dashboard-toolbar__search">
        <MdSearch size={20} aria-hidden="true" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="dashboard-toolbar__input"
          aria-label="Cari properti"
        />
      </div>

      <div className="dashboard-toolbar__filter">
        <select
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
          className="dashboard-toolbar__select"
          aria-label="Filter status listing"
        >
          <option value="all">Semua Status</option>
          <option value="for_sale">Dijual</option>
          <option value="for_rent">Disewakan</option>
          <option value="draft">Draft</option>
          <option value="published">Dipublikasikan</option>
        </select>
      </div>

      <div className="dashboard-toolbar__filter">
        <select
          value={approvalStatusFilter}
          onChange={(e) => onApprovalStatusChange(e.target.value)}
          className="dashboard-toolbar__select"
          aria-label="Filter approval status"
        >
          <option value="all">Semua Approval</option>
          <option value="draft">Draft</option>
          <option value="pending">Menunggu</option>
          <option value="approved">Disetujui</option>
          <option value="rejected">Ditolak</option>
        </select>
      </div>

      <button
        type="button"
        onClick={onRefresh}
        className="dashboard-btn dashboard-btn--secondary dashboard-toolbar__refresh"
        disabled={refreshing}
      >
        <MdRefresh size={18} className={refreshing ? "spin" : ""} />
        {refreshing ? "Memperbarui..." : "Muat Ulang"}
      </button>
    </div>
  );
};

export default DashboardPropertyFilter;
